import { render, staticRenderFns } from "./ApplicationRegionCriteria.vue?vue&type=template&id=213c0623&"
import script from "./ApplicationRegionCriteria.vue?vue&type=script&lang=js&"
export * from "./ApplicationRegionCriteria.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
